import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BhutilProvider } from '../../providers/bhutil/bhutil';

/*
  Generated class for the BeerCcButtonProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export enum ButtonTypes {
  DETAILS_BUTTON,
  DETAILS_CHILD,
  NONE,
  PARENT,
  ONE_TO_FIVE_PARENT,
  ONE_TO_FIVE_CHILD,
  COLOR_PARENT,
  /*COLOR_CHILD,
  COLOR_CHILD_IMAGE,*/
  CELL_COLOR,
  CELL_CLARITY_NO_IMAGE,
  CELL_CLARITY_IMAGE
}

@Injectable({
    providedIn: 'root'
})
export class BeerCcButtonProvider {

  private buttonsTemplate: Array<any>;

  constructor(public http: HttpClient, private bhutil: BhutilProvider) {
    console.log('Hello BeerCcButtonProvider Provider');

    this.buttonsTemplate = [
      {
        identifier: "color1",
        buttons: [
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#FFFFCD"],
            selected: false,
            label: "",
            key: "col1"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#FFC000"],
            selected: false,
            label: "",
            key: "col3"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#CC6601"],
            selected: false,
            label: "",
            key: "col5"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#CC0001"],
            selected: false,
            label: "",
            key: "col7"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#080808"],
            selected: false,
            label: "",
            key: "col9"
          }
        ],
        selected: false,
        type: ButtonTypes.NONE
      },
      {
        identifier: "color2",
        buttons: [
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#FFFF01"],
            selected: false,
            label: "",
            key: "col2"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#FE9900"],
            selected: false,
            label: "",
            key: "col4"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#A94124"],
            selected: false,
            label: "",
            key: "col6"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#5B220E"],
            selected: false,
            label: "",
            key: "col8"
          }
        ],
        selected: false,
        type: ButtonTypes.NONE
      }
    ];

  }
  public getButtons(): Array<any> {
    return this.bhutil.createCopy(this.buttonsTemplate);
  }

}
